import { render, staticRenderFns } from "./WavePickTote.vue?vue&type=template&id=2db59af4&"
import script from "./WavePickTote.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WavePickTote.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./WavePickTote.vue?vue&type=style&index=0&id=2db59af4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports